import { useEffect, useState } from "react";
import useNav from "src/hooks/useNav";
import MonthSearchForm from "./month-search-form";
import AttendanceTable from "./attendance-table";
import { InputCheckbox } from "src/components/common/form/input-checkbox";

const StudentAttendance = ({ studentInfo, readOnly, children }) => {
  const { currentMonth } = useNav();
  const [date, setDate] = useState(null);
  const [showInvalid, setShowInvalid] = useState(
    localStorage.getItem("showInvalid") === "true"
  );

  useEffect(() => {
    if (currentMonth) {
      setDate(currentMonth);
    }
  }, [currentMonth]);

  return (
    <div className="container-fluid student-attendance-container">
      {children}
      <div className="row m-0 h-100">
        <div className="card pb-1 pt-2 h-100">
          <div className="row m-0 mt-2 my-2">
            <MonthSearchForm
              initialDate={date}
              onSubmit={setDate}
              readOnly={readOnly}
            />
          </div>
          <InputCheckbox
            label="無効になった出欠データを表示する"
            checked={showInvalid}
            name="showInvalid"
            onChange={e => {
              setShowInvalid(e.target.checked);
              localStorage.setItem("showInvalid", e.target.checked);
            }}
          />
          <AttendanceTable
            studentInfo={studentInfo}
            date={date}
            showInvalid={showInvalid}
          />
        </div>
      </div>
    </div>
  );
};

export default StudentAttendance;
